import {
  createContext,
  useContext,
  ReactNode,
  useState,
  SetStateAction,
  Dispatch,
  useEffect
} from 'react';

interface AccordionContextProps {
  shouldOpenReview: boolean;
  setOpenReview: Dispatch<SetStateAction<boolean>>;
}
const AccordionContext = createContext({} as AccordionContextProps);

interface AccordionContextProviderProps {
  children: ReactNode;
}

export const AccordionContextProvider = ({ children }: AccordionContextProviderProps) => {
  const [shouldOpenReview, setOpenReview] = useState(false);
  const value = { shouldOpenReview, setOpenReview };
  return <AccordionContext.Provider value={value}>{children}</AccordionContext.Provider>;
};

export const useAccordionContext = () => {
  const { shouldOpenReview, setOpenReview } = useContext(AccordionContext);

  const openReview = () => {
    setOpenReview(true);
  };

  useEffect(() => {
    if (shouldOpenReview) {
      setOpenReview(false);
    }
  }, [setOpenReview, shouldOpenReview]);

  return { shouldOpenReview, openReview };
};
